<template>
    <div class="fuwu-base">
        <router-view/>
        <div v-if="$route.meta.footer.show" class='distributor-footer-wrap'>
            <mt-tabbar v-model='home_selected' fixed class="distributor-footer">
                <mt-tab-item class='item-wrap' id='home_index'><router-link :to="{ name: 'HomeIndex'}" class='item'><i v-bind:class='["iconfont", (home_selected=="home_index")?"icon-homepage_fill":"icon-homepage"]' /><span class='text'>首页</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' id='member_order'><router-link :to="{ name: 'FuwuManageOrderList'}" class='item'><i v-bind:class='["iconfont", (home_selected=="member_order")?"icon-quanbudingdan1":"icon-quanbudingdan1"]' /><span class='text'>订单</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' id='member_index'><router-link :to="{ name: 'FuwuManageInfo'}" class='item'><i v-bind:class='["iconfont", (home_selected=="member_index")?"icon-people_fill":"icon-people"]' /><span class='text'>我的</span></router-link></mt-tab-item>
            </mt-tabbar>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'FuwuManageBase',
  data () {
    return {
      home_selected: 'member_index'
    }
  },
  computed: {

  },
  created: function () {

  }
}
</script>
<style lang="scss">
    .fuwu-base .mint-button--primary{background:#20ad20 !important;}
    .fuwu-base .distributor-footer-wrap .distributor-footer .item-wrap.is-selected .item{color:#20ad20}
</style>
